import { render } from "./Scale.vue?vue&type=template&id=5cc48fe8&scoped=true"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"

import "./Scale.vue?vue&type=style&index=0&id=5cc48fe8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5cc48fe8"

export default script